import { useTenantContext } from '@/contexts/TenantContext';
import { useAvailableTenants } from '@/hooks/useAvailableTenants';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { Building2 } from 'lucide-react';

export function TenantSwitcher() {
  const { activeTenantId, userDefaultTenantId, setActiveTenantId, isSwitched } = useTenantContext();
  const { tenants, isLoading, hasMultipleTenants } = useAvailableTenants();

  console.log('🏢 TenantSwitcher: Render state:', {
    isLoading,
    tenantsCount: tenants.length,
    hasMultipleTenants,
    activeTenantId,
    userDefaultTenantId,
  });

  // Show loading skeleton while loading
  if (isLoading) {
    console.log('🏢 TenantSwitcher: Showing loading skeleton');
    return <Skeleton className="h-8 w-[180px]" />;
  }

  // Don't show if user doesn't have multiple tenants
  if (!hasMultipleTenants) {
    console.log('🏢 TenantSwitcher: Not showing (no multiple tenants)');
    return null;
  }

  const activeTenant = tenants.find(t => t.id === activeTenantId);
  
  console.log('🏢 TenantSwitcher: Active tenant:', activeTenant?.name, 'ID:', activeTenantId);

  return (
    <div className="flex items-center gap-2">
      <Building2 className="h-4 w-4 text-muted-foreground flex-shrink-0" />
      <Select value={activeTenantId || undefined} onValueChange={setActiveTenantId}>
        <SelectTrigger className="w-[180px] sm:w-[200px]">
          <SelectValue>
            <div className="flex items-center gap-2">
              <span className="truncate">{activeTenant?.name || 'Loading...'}</span>
              {isSwitched && <Badge variant="outline" className="text-xs flex-shrink-0">Switched</Badge>}
            </div>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="bg-background z-50">
          {tenants.map((tenant) => (
            <SelectItem key={tenant.id} value={tenant.id}>
              <div className="flex items-center gap-2">
                <span>{tenant.name}</span>
                {tenant.id === userDefaultTenantId && (
                  <Badge variant="secondary" className="text-xs">Default</Badge>
                )}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
